import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';

import { GoModalService } from './go-modal.service';

export const ngxGoModalServiceModule = angular.module('ngxGoModalServiceModule', [])
	.factory('ngxGoModalService', downgradeInjectable(GoModalService) as any)
	.name;
